export default {
  title: 'Einzelheiten zum Versand',
  buttons: {
    save: 'Speichern',
  },
};
